import { useRouter } from "@tanstack/react-router"
import { useCallback } from "react"

export const useBackAction = (): { handleBack: () => void } => {
  const router = useRouter()
  const handleBack = useCallback(() => {
    router.history.back()
  }, [router])

  return {
    handleBack,
  } as const
}
